{
  "admission": "Admission",
  "transfer": "Transfer",
  "visit": "Visit",
  "type": "Encounter Type",
  "status": "Status",
  "location": "Location",
  "attendingPhysician": "Attending Physician",
  "admitDate": "Admit Date",
  "dischargeDate": "Discharge Date",
  "chiefComplaint": "Chief Complaint",
  "diagnosis": "Diagnosis",
  "class": {
    "label": "Class",
    "values": {
      "emergency": "Emergency",
      "inpatient": "Inpatient",
      "outpatient": "Outpatient",
      "observation": "Observation",
      "ambulatory": "Ambulatory",
      "homeHealth": "Home Health",
      "virtual": "Virtual / Telehealth"
    }
  },
  "statusValues": {
    "label": "Status",
    "values": {
      "pending": "Pending",
      "arrived": "Arrived",
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled"
    }
  },
  "admissionSource": {
    "label": "Admission Source",
    "none": "—",
    "values": {
      "emergency": "Emergency Department",
      "clinicReferral": "Clinic Referral",
      "physicianReferral": "Physician Referral",
      "transfer": "Transfer from Another Facility",
      "self": "Self-Referral / Walk-in",
      "courtLaw": "Court / Law Enforcement"
    }
  },
  "admissionType": {
    "label": "Admission Type",
    "none": "—",
    "values": {
      "elective": "Elective",
      "emergency": "Emergency",
      "urgent": "Urgent",
      "newborn": "Newborn",
      "trauma": "Trauma"
    }
  },
  "acuity": {
    "label": "Acuity",
    "none": "—",
    "values": {
      "1": "1 — Resuscitation",
      "2": "2 — Emergent",
      "3": "3 — Urgent",
      "4": "4 — Less Urgent",
      "5": "5 — Non-Urgent"
    },
    "shortValues": {
      "1": "Resuscitation",
      "2": "Emergent",
      "3": "Urgent",
      "4": "Less Urgent",
      "5": "Non-Urgent"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "New Encounter",
    "subtitle": "Start a new visit / admission for this patient.",
    "sections": {
      "visit": "Visit",
      "reasonForVisit": "Reason for Visit",
      "admission": "Admission"
    },
    "fields": {
      "facility": "Facility",
      "encounterClass": "Encounter Class",
      "encounterType": "Encounter Type",
      "department": "Department",
      "attendingProvider": "Attending Provider",
      "acuity": "Acuity",
      "visitReason": "Visit Reason",
      "chiefComplaint": "Chief Complaint",
      "admissionSource": "Admission Source",
      "admissionType": "Admission Type"
    },
    "placeholders": {
      "selectFacility": "Select facility",
      "none": "—",
      "encounterType": "e.g. Annual Physical, A&E Visit",
      "visitReason": "Short label, e.g. Follow-up, Annual Physical",
      "chiefComplaint": "Patient's stated reason in their own words"
    },
    "providerFallback": "Provider #{{id}}",
    "submit": "Create Encounter",
    "validation": {
      "facilityRequired": "Facility is required",
      "encounterClassRequired": "Encounter class is required"
    },
    "createdSuccess": "Encounter created",
    "createError": "Failed to create encounter"
  },
  "detail": {
    "loading": "Loading encounter...",
    "notFound": "Encounter not found",
    "loadError": "Failed to load encounter",
    "retry": "Retry",
    "returnToDashboard": "Return to Dashboard",
    "header": {
      "title": "Encounter {{number}}",
      "facilityLabel": "Facility #{{id}}",
      "departmentLabel": "Dept #{{id}}",
      "locationLabel": "Location #{{id}}",
      "admittedLabel": "Admitted: {{datetime}}"
    },
    "actions": {
      "transfer": "Transfer",
      "discharge": "Discharge"
    },
    "tabs": {
      "overview": "Overview",
      "orders": "Orders",
      "results": "Results",
      "medications": "Medications",
      "notes": "Notes",
      "billing": "Billing"
    },
    "overview": {
      "chiefComplaint": "Chief Complaint",
      "visitReason": "Visit Reason",
      "attendingProvider": "Attending Provider",
      "acuityLevel": "Acuity Level",
      "providerFallback": "Provider #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "Event Timeline",
      "empty": "No events recorded",
      "admittedTitle": "Admitted",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "No chief complaint",
      "orderTitle": "Order: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "Result: {{type}}"
    },
    "orders": {
      "title": "Orders",
      "newOrder": "+ New Order",
      "empty": "No orders for this encounter",
      "metaLine": "{{number}} | {{type}} | Priority: {{priority}}"
    },
    "results": {
      "title": "Results",
      "empty": "No results for this encounter",
      "criticalBadge": "CRITICAL",
      "viewLink": "View",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "Medications",
      "newMedication": "+ New Medication",
      "empty": "No medications for this encounter",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "Clinical notes module coming soon",
      "goToClinicalNotes": "Go to Clinical Notes"
    },
    "billing": {
      "comingSoon": "Billing module coming soon"
    }
  },
  "census": {
    "title": "Bed Board / Census",
    "subtitle": "Real-time bed occupancy and patient census",
    "refresh": "Refresh",
    "facilityName": "Singapore General Hospital",
    "capacitySummary": "{{occupied}} occupied / {{total}} total beds",
    "occupancyLabel": "{{percent}}% occupancy",
    "stats": {
      "totalCapacity": "Total Capacity",
      "occupied": "Occupied",
      "available": "Available",
      "pendingDischarge": "Pending Discharge"
    },
    "unitFilter": {
      "all": "All Units",
      "er": "A&E",
      "icu": "ICU",
      "medsurg": "Med/Surg",
      "obs": "Observation",
      "peds": "Paediatrics",
      "maternity": "Maternity"
    },
    "roleView": {
      "nurse": "Nurse View",
      "physician": "Physician View",
      "bedManager": "Bed Manager View"
    },
    "viewMode": {
      "grid": "Grid view",
      "table": "Table view"
    },
    "loading": "Loading census data...",
    "columns": {
      "patient": "Patient",
      "mrn": "MRN",
      "admitDate": "Admit Date",
      "status": "Status",
      "acuity": "Acuity",
      "isolation": "Isolation",
      "fallRisk": "Fall Risk",
      "codeStatus": "Code Status",
      "chiefComplaint": "Chief Complaint",
      "attending": "Attending",
      "los": "LOS",
      "locationBed": "Location / Bed",
      "transferStatus": "Transfer Status",
      "expectedDischarge": "Expected Discharge",
      "actions": "Actions"
    },
    "values": {
      "unknownPatient": "Unknown",
      "none": "None",
      "notAvailable": "N/A",
      "pending": "Pending",
      "empty": "--",
      "providerFallback": "Provider #{{id}}",
      "locationLabel": "Location #{{id}}",
      "losDays": "{{days}}d"
    },
    "codeStatusTooltip": "Code status is available on the patient chart",
    "actionsMenu": {
      "label": "Actions",
      "viewChart": "View Chart",
      "transfer": "Transfer",
      "assignAttending": "Assign Attending",
      "discharge": "Discharge"
    },
    "empty": "No active encounters found",
    "department": {
      "filteredTo": "Showing {{name}} only",
      "idLabel": "Department {{id}}",
      "showAll": "Show all departments"
    },
    "facility": {
      "label": "Facility",
      "allFacilities": "All facilities",
      "idLabel": "Facility {{id}}"
    }
  },
  "discharge": {
    "label": "Discharge",
    "title": "Discharge Workflow",
    "encounterLabel": "Encounter {{number}}",
    "printButton": "Print Discharge",
    "loading": "Loading encounter...",
    "notFound": "Encounter not found",
    "returnToDashboard": "Return to Dashboard",
    "notActive": "This encounter is not active (status: {{status}})",
    "backToEncounter": "Back to Encounter",
    "progress": {
      "requiredMissingTooltip": "Required fields missing",
      "tasksRemainingTooltip": "Some tasks remaining"
    },
    "steps": {
      "summary": "Discharge Summary",
      "medications": "Medications",
      "followup": "Follow-up",
      "instructions": "Instructions",
      "nursing": "Nursing Tasks",
      "signoff": "Attending Sign-off",
      "review": "Review & Confirm"
    },
    "summary": {
      "title": "Discharge Summary",
      "diagnosisLabel": "Discharge Diagnosis *",
      "diagnosisPlaceholder": "Enter discharge diagnosis...",
      "diagnosisCodeLabel": "Discharge Diagnosis Code (ICD-10)",
      "diagnosisCodePlaceholder": "Search ICD-10 code...",
      "proceduresLabel": "Procedures Performed",
      "proceduresPlaceholder": "List procedures performed during this encounter...",
      "conditionLabel": "Condition at Discharge *"
    },
    "condition": {
      "values": {
        "stable": "Stable",
        "improved": "Improved",
        "unchanged": "Unchanged",
        "worsened": "Worsened",
        "critical": "Critical"
      }
    },
    "medications": {
      "title": "Discharge Medications",
      "instructions": "Review each medication and decide whether to continue, stop, or modify at discharge.",
      "actions": {
        "continue": "Continue",
        "stop": "Stop",
        "modify": "Modify"
      },
      "modifiedPlaceholder": "Enter modified instructions...",
      "empty": "No active medications for this encounter"
    },
    "medAction": {
      "values": {
        "continue": "continue",
        "stop": "stop",
        "modify": "modify"
      }
    },
    "followup": {
      "title": "Follow-up Appointments",
      "providerLabel": "Follow-up Provider",
      "providerPlaceholder": "Provider name or specialty...",
      "dateLabel": "Follow-up Date",
      "notesLabel": "Additional Notes",
      "notesPlaceholder": "Any additional follow-up notes..."
    },
    "instructions": {
      "title": "Patient Instructions",
      "generalLabel": "General Instructions",
      "generalPlaceholder": "General discharge instructions for the patient...",
      "dietaryLabel": "Dietary Instructions",
      "dietaryPlaceholder": "Any dietary restrictions or recommendations...",
      "activityLabel": "Activity Restrictions",
      "activityPlaceholder": "Physical activity limitations...",
      "warningSignsLabel": "Warning Signs to Watch For",
      "warningSignsPlaceholder": "Symptoms that should prompt the patient to return or seek care..."
    },
    "nursing": {
      "title": "Nursing Tasks",
      "instructions": "Complete the following checklist before discharge. These tasks are informational and do not require an API call.",
      "tasks": {
        "removeIv": "Remove IV access",
        "discontinueMonitoring": "Discontinue monitoring equipment",
        "patientEducation": "Patient education completed",
        "medsReviewed": "Discharge medications reviewed with patient",
        "belongingsReturned": "Personal belongings returned",
        "transportArranged": "Transport arranged"
      }
    },
    "signoff": {
      "title": "Attending Sign-off",
      "instructions": "Review the discharge summary below and provide attending sign-off.",
      "diagnosisHeading": "Discharge Diagnosis",
      "notProvided": "Not provided",
      "medicationsHeading": "Discharge Medications",
      "noMedications": "No medications to reconcile",
      "signedCompleted": "Attending sign-off completed.",
      "signAsAttending": "Sign as Attending",
      "requiresAttendingSignoff": "Requires attending physician sign-off"
    },
    "review": {
      "title": "Review & Confirm Discharge",
      "summaryHeading": "Discharge Summary",
      "fields": {
        "diagnosis": "Diagnosis:",
        "procedures": "Procedures:",
        "condition": "Condition:",
        "provider": "Provider:",
        "date": "Date:",
        "notes": "Notes:",
        "general": "General:",
        "diet": "Diet:",
        "activity": "Activity:",
        "warningSigns": "Warning Signs:"
      },
      "medicationsHeading": "Medication Reconciliation",
      "noMedications": "No medications to reconcile",
      "followupHeading": "Follow-up",
      "instructionsHeading": "Patient Instructions",
      "noInstructions": "No instructions provided",
      "pendingOrdersWarning": "There may be pending orders or unsigned notes. Verify before completing discharge.",
      "diagnosisRequired": "Discharge diagnosis is required before completing the discharge.",
      "empty": "--"
    },
    "nav": {
      "previous": "Previous",
      "next": "Next",
      "complete": "Complete Discharge"
    },
    "toast": {
      "success": "Patient discharged successfully",
      "error": "Failed to complete discharge"
    }
  },
  "components": {
    "transferDialog": {
      "title": "Transfer Encounter",
      "description": "Move the patient to a different location in the facility.",
      "targetLocationLabel": "Target Location",
      "loadingLocations": "Loading locations…",
      "selectLocation": "Select a location",
      "emptyState": "No other active locations in this facility.",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "e.g. Isolation required, ICU step-down, higher acuity bed",
      "actions": {
        "transfer": "Transfer"
      },
      "toasts": {
        "success": "Encounter transferred",
        "error": "Failed to transfer encounter"
      }
    },
    "assignAttendingDialog": {
      "title": "Assign Attending Provider",
      "description": "Set the attending provider responsible for this encounter.",
      "providerLabel": "Attending Provider",
      "loadingProviders": "Loading providers…",
      "selectProvider": "Select a provider",
      "emptyState": "No active providers in this facility.",
      "actions": {
        "assign": "Assign"
      },
      "toasts": {
        "success": "Attending provider assigned",
        "error": "Could not assign attending provider"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "Available",
        "occupied": "Occupied",
        "reserved": "Reserved",
        "cleaning": "Cleaning",
        "closed": "Closed",
        "isolated": "Isolated",
        "contaminated": "Contaminated"
      },
      "acuityLegendLabel": "ESI Acuity:",
      "empty": "No units configured",
      "summary": {
        "available_one": "{{count}} available",
        "available_other": "{{count}} available",
        "occupied_one": "{{count}} occupied",
        "occupied_other": "{{count}} occupied",
        "reserved_one": "{{count}} reserved",
        "reserved_other": "{{count}} reserved",
        "cleaning_one": "{{count}} cleaning",
        "cleaning_other": "{{count}} cleaning",
        "closed_one": "{{count}} closed",
        "closed_other": "{{count}} closed",
        "isolated_one": "{{count}} isolated",
        "isolated_other": "{{count}} isolated",
        "contaminated_one": "{{count}} contaminated",
        "contaminated_other": "{{count}} contaminated"
      }
    },
    "protocolPanel": {
      "title": "Protocol Enrollments",
      "enroll": "Enroll",
      "availableProtocols": "Available Protocols",
      "loadingProtocols": "Loading protocols...",
      "noProtocols": "No protocols available",
      "stepBadge": "Step {{current}}/{{total}}",
      "loadingEnrollments": "Loading enrollments...",
      "noEnrollments": "No active protocol enrollments",
      "completeStep": "Complete Step",
      "toasts": {
        "enrollSuccess": "Enrolled in protocol",
        "enrollError": "Failed to enroll in protocol",
        "advanceSuccess": "Step completed",
        "advanceError": "Failed to advance step"
      }
    }
  }
}
